import produce from 'immer'
import {
  READINGS_LOAD,
  READINGS_LOAD_SUCCESS,
  READINGS_LOAD_FAIL
} from './actions'

const initialState = {
  loading: false,
  error: null,
  data: {}
}

export const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case READINGS_LOAD: {
        draft.loading = true
        draft.error = null
        return
      }
      case READINGS_LOAD_SUCCESS: {
        draft.loading = false
        draft.error = null
        draft.data = action.readings
        return
      }
      case READINGS_LOAD_FAIL: {
        draft.loading = false
        draft.error = action.error
        return
      }
      default:
        return
    }
  })
